// btw-front/src/components/admin/dashboard/performanceSort.js
// [파트너 실적] 탭 테이블 정렬 — 라우터·i18n 의존 없는 순수 함수(단위 테스트 대상)

// 숫자 컬럼 — 처음 클릭 시 큰 값부터(내림차순) 보여준다. 파트너사명만 가나다순(오름차순)으로 시작
export const NUMERIC_SORT_KEYS = ["total", "inProgress", "adoption", "lost", "poTotal"];

// 파트너 실적 행 정렬 — sort 가 null 이면 서버 기본 순서(누적 PO 금액 내림차순) 유지.
// 값이 같으면 파트너사명 가나다순으로 순서를 고정한다(정렬 방향과 무관).
export function sortPerformanceRows(rows, sort) {
  if (!sort) return rows;
  const mul = sort.dir === "asc" ? 1 : -1;
  const byName = (a, b) =>
    (a.partner.companyName || "").localeCompare(b.partner.companyName || "", "ko");
  return [...rows].sort((a, b) => {
    if (sort.key === "partner") return byName(a, b) * mul;
    return ((a[sort.key] || 0) - (b[sort.key] || 0)) * mul || byName(a, b);
  });
}
